import React from 'react';

/**
 * OptimizedImage - A component for image optimization with lazy loading, responsive sizing, and proper alt attributes
 * 
 * @param {string} src - Image source URL
 * @param {string} alt - Alt text (required for SEO and accessibility)
 * @param {string} className - CSS classes to apply to the image
 * @param {string} width - Image width (for sizing optimization)
 * @param {string} height - Image height (for sizing optimization)
 * @param {object} srcSet - Responsive image sources { mobile, tablet, desktop }
 * @param {string} title - Image title attribute (optional)
 * @param {function} onLoad - Callback when image loads
 * @param {function} onError - Callback on image error
 */
const OptimizedImage = ({
    src,
    alt = 'Image',
    className = '',
    width,
    height,
    srcSet,
    sizes,
    title,
    onLoad,
    onError,
    ...props
}) => {
    return (
        <img
            src={src}
            alt={alt}
            title={title || alt}
            className={className}
            loading="lazy"
            width={width}
            height={height}
            srcSet={srcSet}
            sizes={sizes}
            onLoad={onLoad}
            onError={onError}
            {...props}
        />
    );
};

export default OptimizedImage;
